import { useLocation } from 'react-router-dom'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ApiUrlPath, AppMsg, Filter, X_AUTH_TOKEN } from 'cat-shared/utils'
import { fetch, getAbortController, getLocalAuthUser } from 'client/services'
import { TGetQuestionsData } from 'client/api/useGetQuestions/useGetQuestions'

type TData = {
  msg: AppMsg
}

type TError = {
  msg: AppMsg
}

type TVariables = {
  questionId: string
}

type Args = {
  onSuccess: (data: TData) => void
  onError: (err: TError) => void
}

export default ({ onSuccess, onError }: Args) => {
  const queryClient = useQueryClient()
  const { pathname } = useLocation()

  const deleteQuestion = async ({ questionId }: TVariables) => {
    const token = getLocalAuthUser().token

    const abortController = getAbortController(25)

    const res = await fetch(
      ApiUrlPath.DeleteQuestion +
        '?' +
        new URLSearchParams({
          _id: String(questionId),
        }),
      {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', [X_AUTH_TOKEN]: token || '' },
        signal: abortController.signal,
      }
    )

    abortController.clear()

    if (res.ok) {
      const queryKey = [ApiUrlPath.GetQuestions] as string[]
      if (pathname === '/home') {
        queryKey.push(Filter.Top)
      }
      queryClient.setQueryData(queryKey, (data: TGetQuestionsData) => {
        return {
          count: data.count - 1,
          data: data.data.filter(q => q._id.toString() !== questionId),
        }
      })

      const body = (await res.json()) as TData
      return Promise.resolve(body)
    } else {
      const err = (await res.json()) as TError
      return Promise.reject(err)
    }
  }

  return useMutation<TData, TError, TVariables>(deleteQuestion, {
    onSuccess,
    onError,
  })
}
